var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mobileHeader"},[_c('div',{staticClass:"headerbox"},_vm._l((_vm.headerList),function(item){return _c('div',{key:item.id,staticClass:"header-item",class:_vm.menuId == item.id ? 'active' : '',attrs:{"id":`menu${item.id}`},on:{"click":function($event){return _vm.onChlick(item)}}},[_vm._v(" "+_vm._s(item.name)+" ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }